<template>
    <div>
        <div class="table-wrapper">
            <div class="query-box">
                <Form ref="formInline1" :model="formInline1"  inline :label-width="100" >
                    <div class="search-right-wrapper">
                        <Row>
                                <Button style="float: left;" type="primary" @click="handleRole()">新增角色</Button>
                                <FormItem label="角色名称：" prop="name">
                                    <Input v-model="formInline1.name" @on-enter="handleQuery" placeholder="请输入角色名称"></Input>
                                    <Input style="display: none"></Input>
                                </FormItem>
                                <Button style="float: right;" type="primary" @click="handleQuery">查询</Button>
                        </Row>
                    </div>
                </Form>
            </div>
            <Table border :loading="loading" :columns="tableColumns" :data="tableData" highlight-row>
                <template slot-scope="{ row, index }" slot="action">
                    <Button span class="pointer" type="text" size="small" @click="handleRole(row)">修改</Button>
                    <Button span class="pointer" type="text" size="small" @click="handleDelete(row.id)">删除</Button>
                </template>
            </Table>
            <div class="t-page">
                <Page :total="totalCount" :page-size="pageSize" :current="page"
                      @on-change="changePage" @on-page-size-change="pageSizeChange"
                      show-elevator show-sizer show-total transfer>
                </Page>
            </div>
        </div>
        <Modal v-model="modelMenus" footer-hide class-name="centerModal" width="720" :title="roleId ? '新增角色':'修改角色'">
            <div class="form-list" style="height: calc(80vh);overflow-y: scroll;overflow-x: hidden;">
                <Form  ref="formInline" :model="formInline" :rules="ruleInline" inline :label-width="100" label-position="right">
                    <Row :gutter="24">
                        <Col span="12">
                            <FormItem label="角色名称：" prop="roleName">
                                <Input v-model="formInline.roleName" placeholder="请输入"></Input>
                            </FormItem>
                        </Col>
                        <!--<Col span="12">-->
                            <!--<FormItem label="添加时间：" prop="auditor">-->
                                <!--<Input readonly v-model="formInline.auditor" placeholder="请输入"></Input>-->
                            <!--</FormItem>-->
                        <!--</Col>-->
                    </Row>
                    <Table :columns="tableColumns1" :data="tableData1"
                           row-key="id" :load-data="handleLoadData"
                        @on-selection-change="handleSelect"
                        ref="selection" highlight-row>
                        <!-- <template slot-scope="{ row, index }" slot="authCode">
                            <RadioGroup v-model="tableData1[index].authCode">
                                <Radio label="manage">管理</Radio>
                                <Radio label="view">查看</Radio>
                            </RadioGroup>
                        </template> -->
                    </Table>
                </Form>
                <Row>
                    <Col :span="8" offset="16" style="margin-top:16px;" align="right">
                        <Button type="primary" :loading="loading" @click="handleSubmit('formInline')">提交</Button>
                        <Button style="margin-left:16px;" @click="modelMenus = false">取消</Button>
                    </Col>
                </Row>

            </div>
        </Modal>
    </div>
</template>

<script>
    import tableMixin from '@/components/tableMixin';
    import { mapGetters } from 'vuex'
    export default {
        mixins: [tableMixin],
        data(){
            return {
                roleId: '',
                id: '',
                tableData1: [],
                ruleInline: {
                    roleName: [
                        { required: true,  message: '角色名称不能为空', trigger: 'blur' }
                    ],
                },
                modelMenus: false,
                formInline:{
                    roleName:'',
                },
                formInline1:{
                    name:'',
                },
                tableColumns1:[
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: '菜单名称' ,
                        key: 'name',
                        tree: true
                    },
                    // {
                    //     title: '菜单',
                    //     slot: 'menus',
                    // }
                ],
                tableColumns:[
                    {
                        title: '序号',
                        type: 'index',
                        width: 70,
                        align: 'center'
                    },
                    {
                        title: '角色名称',
                        key: 'name',
                        align: 'left'
                    },
                    {
                        title: '添加时间',
                        key: 'createTime',
                        align: 'left'
                    },
                    {
                        title: '操作',
                        slot: 'action',
                        align: 'center',
                        width: 150
                    }
                ],
                tableData:[],
            };
        },
        computed:{
            ...mapGetters(['permissions']),
        },
        created(){

        },
        mounted(){
        },
        watch: {
        },
        methods: {
            changePage(val) {
                this.page = val
                this.getTableData()
            },
            pageSizeChange(val) {
                this.pageSize = val
                this.getTableData()
            },

            // 删除
            handleDelete(id){
                this.$Modal.confirm({
                    title: '提示',
                    content: '确认删除该条吗？',
                    onOk: () => {
                        this.$Message.loading({
                            content: '正在删除...',
                            duration: 0
                        });
                        this.axios({
                            method: 'delete',
                            url: `/role/del/${id}`,
                        }).then( (response)=>{
                            this.$Message.destroy();
                            this.$Message.success('删除成功!');
                            this.getTableData();
                        }).catch( ()=> {
                            this.$Message.destroy();
                        });
                    }
                });
            },
            /*处理操作*/
            handleDeal(name,uuid){
                this.$router.push({
                    name: name,
                    query: {
                        id:uuid
                    }
                });
            },
            /*获取表格数据*/
            getTableData(){
                let param={
                    size:this.pageSize,
                    current:this.page,
                    loginType:localStorage.getItem('loginType'),
                };
                Object.assign(param,this.formInline1);
                this.tableData=[];
                this.loading=true;
                this.axios({
                    method: 'get',
                    url: '/role/queryList',
                    params:param,
                }).then( (response)=> {
                    this.loading=false;
                    if(response.data){
                        this.totalCount = response.data.total;
                        this.tableData=response.data.records;
                    }

                }).catch( ()=> {
                    this.loading=false;
                });
            },
            handleBack(){
                this.$router.go(-1);
            },

            // 新增 编辑角色
            handleRole(row) {
                this.roleId = '';
                if(row){
                    this.roleId = row.id;
                }
                this.tableData1 = [];
                this.modelMenus = true;
                this.getPageData()
            },
            // 获取角色信息
            getPageData(){
                new Promise((resolve, reject)=>{
                    this.axios({
                        method: 'get',
                        url: '/menu/menuList',
                        params:{
                            loginType:localStorage.getItem('loginType')
                        }
                    }).then((response)=>{
                        if(response.data){
                            response.data.forEach(item=>{
                                item.authCode='view';
                                item._checked=false;
                                item._loading = false;
                                item.children = [];
                                item.menus = [];
                            });
                            this.tableData1 = response.data;
                            resolve();
                        }
                    });
                }).then(()=>{
                    if(this.roleId){
                        this.axios({
                            method: 'get',
                            url:`/role/permissions/${this.roleId}`,
                        }).then((response)=>{
                            if(response.data.success){
                                this.formInline=response.data.data;
                                let arr = response.data.data.permissions;
                                for (let i=0;i<arr.length;i++){
                                    for (let j=0;j<this.tableData1.length;j++){
                                        if(arr[i].id === this.tableData1[j].id){
                                            this.tableData1[j]._checked=true;
                                            this.tableData1[j].authCode=arr[i].authCode;
                                            this.tableData1[j].menus = arr[i].menus;
                                        }
                                    }
                                }
                            }
                        });
                    }
                });
            },
            // 表格树加载
            handleLoadData(item, callback){
                this.axios({
                    method: 'get',
                    url: `/menu/loadMenuTree/${item.id}`,
                    params:{
                        loginType:localStorage.getItem('loginType'),
                    }
                }).then((response)=>{
                    if(response.data.success){
                        const data = response.data.data || [];
                        data.forEach(item => {
                            item._checked = false;
                        });
                        // 根据权限设置默认选中
                        item.menus.map(it => {
                            data.forEach(item => {
                                if(it === item.id) {
                                    item._checked = true;
                                }
                            })
                        });
                        callback(data);
                    }
                });
            },
            // 表格选中
            handleSelect(selection){
                for (let j=0;j<this.tableData1.length;j++){
                    if(selection.length===0){
                        this.tableData1[j]._checked=false;
                    }else {
                        for (let i=0;i<selection.length;i++){
                            if(selection[i].id===this.tableData1[j].id){
                                this.tableData1[j]._checked = true;
                                break;
                            }else {
                                this.tableData1[j]._checked = false;
                            }
                        }
                        if(this.tableData1[j].children && this.tableData1[j].children.length) {
                            const arr = this.tableData1[j].children;
                            for (let k = 0; k<arr.length; k++) {
                                for (let i=0;i<selection.length;i++){
                                    if(selection[i].id===arr[k].id){
                                        this.tableData1[j].children[k]._checked = true;
                                        break;
                                    }else {
                                        this.tableData1[j].children[k]._checked = false;
                                    }
                                }
                            }
                        }


                    }
                }
            },
            /*提交*/
            handleSubmit(name){
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        let data={
                            loginType:localStorage.getItem('loginType'),
                        };
                        Object.assign(data,this.formInline);
                        let permissions=[];
                        this.tableData1.forEach(item=>{
                            if(item._checked){
                                let items = {
                                    id:item.id,
                                    menus: [],
                                    authCode: item.authCode
                                };
                                if (item.children.length == 0) {
                                    items.menus = item.menus;
                                } else {
                                    item.children.map(c => {
                                        if(c._checked){
                                            items.menus.push(c.id);
                                        }
                                    });
                                }
                                permissions.push(items);
                            }
                        });
                        data.permissions=permissions;
                        if(this.roleId) {
                            this.loading=true;
                            this.axios({
                                method: 'post',
                                url: '/role/updateRole',
                                data: data,
                            }).then((response) => {
                                this.loading=false;
                                if(response.data.success){
                                    this.$Message.success('提交成功!');
                                    this.modelMenus = false;
                                    this.getTableData()
                                }else {
                                    this.$Message.warning(response.data.message);
                                }
                            }).catch( ()=> {
                                this.loading=false;
                            });
                        }else {
                            this.axios({
                                method: 'post',
                                url: '/role/checkRole',
                                data: {
                                    roleName: this.formInline.roleName,
                                    id: this.roleId
                                },
                            }).then((response)=>{
                                if(!response.data.data) {
                                    this.loading=true;
                                    this.axios({
                                        method: 'post',
                                        url: '/role/addRole',
                                        data: data,
                                    }).then((response) => {
                                        this.loading=false;
                                        if(response.data.success){
                                            this.$Message.success('提交成功!');
                                            this.modelMenus = false;
                                            this.getTableData()
                                        }else {
                                            this.$Message.warning(response.data.message);
                                        }
                                    }).catch( ()=> {
                                        this.loading=false;
                                    });
                                }else {
                                    this.$Message.error('角色名称重复');
                                }
                            });
                        }
                    } else {
                        this.$Message.error('表单验证未通过!');
                    }
                });
            }
        }
    };
</script>
